module.exports = __webpack_public_path__ + "img/cccc78e.jpg";